/** Flip image horizontally (mirror left-right) */
export function flipHorizontal(source: ImageData): ImageData {
  const { width, height, data: src } = source;
  const output = new ImageData(width, height);
  const dst = output.data;

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const si = (y * width + x) * 4;
      const di = (y * width + (width - 1 - x)) * 4;
      dst[di] = src[si];
      dst[di + 1] = src[si + 1];
      dst[di + 2] = src[si + 2];
      dst[di + 3] = src[si + 3];
    }
  }

  return output;
}

/** Flip image vertically (mirror top-bottom) */
export function flipVertical(source: ImageData): ImageData {
  const { width, height, data: src } = source;
  const output = new ImageData(width, height);
  const dst = output.data;

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const si = (y * width + x) * 4;
      const di = ((height - 1 - y) * width + x) * 4;
      dst[di] = src[si];
      dst[di + 1] = src[si + 1];
      dst[di + 2] = src[si + 2];
      dst[di + 3] = src[si + 3];
    }
  }

  return output;
}
